package dev.lingvo.shared

import kotlinx.serialization.Serializable

/** A read-only estimate request; seats and subscription identity come from the workspace. */
@Serializable
data class PreviewPlanChangeRequest(val plan: Plan)

@Serializable
data class ConfirmPlanChangeRequest(val previewId: String)

@Serializable
data class PlanChangeAcceptedDto(
    val previewId: String,
    val targetPlan: Plan,
    val message: String = "The payment provider accepted the change. Workspace billing is updating.",
)

/** Processor amount in minor currency units, including currencies without fractional units. */
@Serializable
data class PlanChangeMoneyDto(val amount: String, val currency: String, val display: String? = null)

/** An expiring estimate reference; never permission to submit an update without fresh checks. */
@Serializable
data class PlanChangePreviewDto(
    val currentPlan: Plan,
    val targetPlan: Plan,
    val seats: Int,
    val prorationAction: String,
    val proration: PlanChangeMoneyDto,
    val immediateTotal: PlanChangeMoneyDto?,
    val nextTotal: PlanChangeMoneyDto?,
    val recurringTotal: PlanChangeMoneyDto,
    val nextBilledAt: String,
    val previewId: String? = null,
    val expiresAt: String? = null,
)
